var React = require('react');
var createReactClass = require('create-react-class');

var Loader = createReactClass({
        
    render() {
        if ( this.props.load === true){
            document.getElementById('archiveContainer').classList.add('loading');
        }
        else {
            document.getElementById('archiveContainer').classList.remove('loading');            
        }
        
        return (
            <div className={this.props.load === true ? "lds-dual-ring loading": "lds-dual-ring"} id="spinner"></div>
        );

    }

});


export default Loader;